import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
  0% { background-position: -220px 0; }
  100% { background-position: 220px 0; }
`;

// Sizes and colors follow the "Add a Link Preview" design (Main and Fallback artboards).
export const Card = styled.div`
  display: block;
  border-top: 1px solid #e4e1d9;
  background: #fff;
  overflow: hidden;
  position: relative;
  font-weight: normal;

  .lp-image-wrap { height: 118px; width: 100%; background: #e4f3fa; position: relative; }
  .lp-image { display: block; width: 100%; height: 100%; object-fit: cover; }
  .lp-badge { position: absolute; width: 26px; height: 26px; border-radius: 8px; display: flex; align-items: center; justify-content: center; }
  .lp-badge-image { top: 10px; right: 10px; background: rgba(255, 255, 255, 0.92); }
  .lp-badge-compact { top: 14px; right: 16px; background: #f4f2ec; }

  .lp-body { padding: 14px 20px 18px; }
  .lp-body-compact { padding: 16px 20px 18px; position: relative; }

  .lp-site { display: flex; align-items: center; gap: 6px; margin-bottom: 8px; }
  .lp-site-compact { gap: 10px; margin-bottom: 10px; }
  .lp-tile { width: 18px; height: 18px; border-radius: 5px; background: #eaf5f3; color: #106d65; object-fit: cover;
             display: flex; align-items: center; justify-content: center; font-weight: 700; font-size: 10px; flex-shrink: 0; }
  .lp-tile-large { width: 32px; height: 32px; border-radius: 9px; font-size: 14px; }
  .lp-domain { font-size: 11px; letter-spacing: .03em; color: #7c8b88; text-transform: uppercase; }
  .lp-site-name { font-weight: 600; font-size: 13px; color: #172423; }
  .lp-domain-small { font-size: 11px; color: #7c8b88; }

  .lp-title { font-weight: 600; font-size: 15px; line-height: 1.35; color: #172423; margin-bottom: 6px; }
  .lp-title-compact { padding-right: 34px; }
  .lp-desc { font-size: 13px; line-height: 1.5; color: #7c8b88; }
  .lp-title, .lp-desc { display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
`;

export const Skeleton = styled.div`
  background: linear-gradient(90deg, #edebe4 0px, #f5f3ee 60px, #edebe4 120px);
  background-size: 600px 100%;
  animation: ${shimmer} 1.4s infinite linear;
  border-radius: 6px;
`;

export const Note = styled.div`
  margin: -8px 0 24px;
  font-size: 12px;
  color: #7c8b88;

  &.lp-ready { color: #16847a; }
  .anticon { margin-right: 4px; }
`;
